/* The Sunflower Star is a self-reported growing diary saved only in this browser. */
(function () {
  'use strict';
  function init() {
    var root = document.querySelector('[data-kids-sunflower]');
    if (!root || !window.GrowJoyBadges) return;
    var steps = root.querySelectorAll('[data-kids-sunflower-step]');
    var status = root.querySelector('[data-kids-sunflower-status]');
    function render(message) {
      var data = window.GrowJoyBadges.read();
      var progress = data.activities.sunflower || {};
      steps.forEach(function (input) { input.checked = !!progress[input.getAttribute('data-kids-sunflower-step')]; });
      var count = Array.from(steps).filter(function (input) { return input.checked; }).length;
      status.textContent = message || (window.GrowJoyBadges.has('sunflower-star') ? 'Sunflower Star earned! Keep caring for your plant.' : count + ' of 3 discoveries saved.');
    }
    steps.forEach(function (input) {
      input.addEventListener('change', function () {
        var result = window.GrowJoyBadges.sunflowerStep(input.getAttribute('data-kids-sunflower-step'), input.checked);
        render(result.saved ? (result.earned ? 'Amazing! You earned Sunflower Star!' : '') : 'Progress could not be saved on this device.');
      });
    });
    render();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
